import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataServiceService } from '../../service/data-service.service';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  isError?: boolean;
}

@Component({
  selector: 'app-chat-widget',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './chat-widget.component.html',
  styleUrl: './chat-widget.component.scss',
})
export class ChatWidgetComponent {
  isOpen = false;
  pending = false;
  draft = '';
  messages: ChatMessage[] = [];

  constructor(private dataService: DataServiceService) {}

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

  send(): void {
    const question = this.draft.trim();
    if (!question || this.pending) return;

    this.messages.push({ role: 'user', content: question });
    this.draft = '';
    this.pending = true;

    this.dataService.askChat(question).subscribe({
      next: (res) => {
        this.messages.push({ role: 'assistant', content: res.reply });
        this.pending = false;
      },
      error: () => {
        this.messages.push({
          role: 'assistant',
          isError: true,
          content: 'No pude obtener una respuesta en este momento. Intenta de nuevo en unos segundos.',
        });
        this.pending = false;
      },
    });
  }

  trackByIndex(index: number): number {
    return index;
  }
}
